import { createUseStyles } from 'react-jss';
import { Theme } from '@app/theme';
import { EventContentArg } from '@fullcalendar/core';
import { ModeratedTaskSetting } from '../../queries';
import classNames from 'classnames';
import { IconChip } from '@app/core';
import { BaseEvent } from './Calendar';

const useStyles = createUseStyles((theme: Theme) => ({
  container: {
    position: 'relative',
  },
  groupFillChip: {
    position: 'absolute',
    bottom: theme.marginBase,
    left: theme.marginBase,
  },
}));

interface Props {
  eventInfo: EventContentArg;
  settings?: ModeratedTaskSetting;
}

export const CalendarGroupContent = ({ eventInfo, settings }: Props) => {
  const classes = useStyles();

  const event = eventInfo.event.extendedProps as BaseEvent;

  return (
    <div className={classNames('fc-event-main-frame', classes.container)}>
      <div className="fc-event-time">{eventInfo.timeText}</div>
      <div className="fc-event-title-container">
        <div className="fc-event-title fc-sticky">{eventInfo.event.title}</div>
      </div>

      <div className={classes.groupFillChip}>
        <IconChip color="green" icon="ri-team-line">
          {event.attendees?.length || 0}
          {' / '}
          {settings?.numberOfParticipantByMeeting}
        </IconChip>
      </div>
    </div>
  );
};
